import { registerMutation, registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
const API_BASE = '/knowledge-content/v2/import';
export const GET_SMART_COPY_ARTICLE_WARNING = registerQuery({
  fieldName: 'importArticleWarning',
  args: ['articleId'],
  fetcher({
    articleId
  }) {
    return http.get(`${API_BASE}/warning/${articleId}`);
  }
});
export const REVIEW_IMPORT_WARNING = registerMutation({
  fieldName: 'reviewImportWarning',
  args: ['articleId'],
  fetcher({
    articleId
  }) {
    return http.put(`${API_BASE}/warning/review/${articleId}`);
  }
});